import React from 'react';
import { Hero } from '../components/sales/Hero';
import { LeadCopy } from '../components/sales/LeadCopy';
import { ProblemSection } from '../components/sales/ProblemSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { OfferStack } from '../components/sales/OfferStack';
import { Testimonials } from '../components/sales/Testimonials';
import { Guarantee } from '../components/sales/Guarantee';
import { FinalCTA } from '../components/sales/FinalCTA';
import { StickyBuyBar } from '../components/sales/StickyBuyBar';
import { Footer } from '../components/sales/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-dark-DEFAULT text-white font-sans selection:bg-gold selection:text-dark-DEFAULT" data-id="element-216">
      <Hero data-id="element-217" />
      <LeadCopy data-id="element-218" />
      <ProblemSection data-id="element-219" />
      <SolutionSection data-id="element-220" />
      <Testimonials data-id="element-221" />
      <OfferStack data-id="element-222" />
      <Guarantee data-id="element-223" />
      <FinalCTA data-id="element-224" />
      <Footer data-id="element-225" />
      <StickyBuyBar data-id="element-226" />
    </div>;
}